module.exports = __webpack_public_path__ + "img/jllogo.5208e1db.png";